export default __webpack_public_path__ + "static/media/about-gallery2.c58586d6.jpg";